import { useContext } from "react"
import { LocaleContext } from "contexts"
import { siteCountry } from "utils/env"
import countries from "../../../../config/i18n"
import ContactInfo from "./ContactInfo"

const locales = countries[siteCountry] || countries.fi

const InfoKaisa = (props) => {
  const { locale } = useContext(LocaleContext)
  const localeConfig = locales[locale] || Object.values(locales)[0] || {}

  const kaisa = {
    name: "Kaisa Rissanen",
    phone: "+358505053134",
    position: "Head of Legal and Operations",
    email: localeConfig.kaisaEmail,
  }
  return <ContactInfo person={kaisa} {...props} />
}

export default InfoKaisa
